import React, { useState } from 'react';
import moment from 'moment';
import get from 'lodash/get';
import { formatDateToDate, sendMetric } from '@atheneum/api/dist/lib'; // Global States for faster scheduling

import { useStore } from "../../contexts/store"; // Components

import { Schedule } from "../../components/Schedule";
import CalendarInfo from "../../components/CalendarInfo";
import OverviewCalendar from "../../components/OverviewCalendar";
import OverviewAvailabilities from "../../components/OverviewAvailabilities";
import { IconMultiUser, IconMultiUserLarge } from "../../components/IconMultiUser";
import ExpertStatusIcon from "../../components/ExpertStatusIcon";
import Checkbox from "../../components/Checkbox";
import HFComplianceStatus from "../../components/HFComplianceStatus";
import ComplianceButton from "../../components/Compliance";
import IconDown from "../../components/Icon/IconDown";
import Tooltip from "../../components/Tooltip/Tooltip";
import "./style.css";
import { formatInvitationSubject } from "../../helpers";

const Overview = ({
  onDeleteTimeslot,
  growlStore,
  eplModel
}) => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    eplModels,
    disableAddAnotherExpert,
    expertsAdded,
    availabilityStore_imp,
    connectedZoomMeeting,
    sendZoomUpdate
  } = state;
  const [open, setOpen] = useState(false);
  const [experienceOpen, setExperienceOpen] = useState(0);

  const RenderIcon = ({
    id
  }) => {
    let className = 'icon-animate';
    if (open && experienceOpen === id) className += ' icon-rotate';
    return /*#__PURE__*/React.createElement(IconDown, {
      className: className,
      style: {
        marginLeft: '5px'
      },
      onClick: e => {
        experienceOpen === 0 ? setExperienceOpen(id) : setExperienceOpen(0);
        setOpen(!open);
      }
    });
  };

  const RenderExperience = ({
    model
  }) => {
    const experience = get(model.epl, 'relevantExperience.experience', null);
    if (!experience) return null;
    const position = get(experience, 'position.name');
    const companyName = get(experience, 'company.name');
    const experienceDate = formatDateToDate(experience.startDate, experience.endDate, 'MMM YYYY');
    const companyAndExperience = `${companyName} (${experienceDate})`;
    const location = experience.location;
    return /*#__PURE__*/React.createElement("div", {
      className: ""
    }, position && /*#__PURE__*/React.createElement("p", {
      className: "expertsToAddExperience"
    }, position), companyAndExperience && /*#__PURE__*/React.createElement("p", {
      className: "expertsToAddExperience"
    }, companyAndExperience), location && /*#__PURE__*/React.createElement("p", {
      className: "expertsToAddExperience"
    }, location));
  };

  const RenderEmailMissing = ({
    expert
  }) => {
    const isEmailMissing = !expert.email;

    if (isEmailMissing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "message"
      }, /*#__PURE__*/React.createElement("span", {
        className: "message__error"
      }, "Email missing (Cannot invite expert)"));
    } else {
      return null;
    }
  };

  const checkExperiences = experiences => {
    let check = true;
    experiences.forEach(e => {
      const start = new Date(e.startDate);
      const end = e.endDate === null ? new Date() : new Date(e.endDate);

      if (end.getTime() < start.getTime()) {
        check = e;
      }
    });
    return check;
  };

  const RenderExperienceWarnings = e => {
    var _e$company, _e$position;

    return e ? /*#__PURE__*/React.createElement("div", {
      className: "message"
    }, /*#__PURE__*/React.createElement("span", {
      className: "message__error"
    }, `${(_e$company = e.company) === null || _e$company === void 0 ? void 0 : _e$company.name} - ${(_e$position = e.position) === null || _e$position === void 0 ? void 0 : _e$position.name} has start date larger than end date.`, /*#__PURE__*/React.createElement("br", null), `Start Date: ${moment(e.startDate).format('DD.MM.YYYY')} End Date: ${moment(e.endDate === null ? new Date() : e.endDate).format('DD.MM.YYYY')}`)) : null;
  };

  const RenderFeeAction = ({
    model
  }) => {
    const {
      epl
    } = model;
    const {
      staticData
    } = availabilityStore_imp;

    if (epl.eplStatusId === staticData.CONST.EPL_STATUSES.INTERVIEWED && !epl.feeEntry) {
      return /*#__PURE__*/React.createElement("div", {
        className: "message"
      }, /*#__PURE__*/React.createElement("span", {
        className: "message__error"
      }, "Hon. & Fee Bundle missing"));
    }

    return null;
  };

  const RenderWarnings = ({
    model
  }) => {
    const {
      staticData,
      project
    } = availabilityStore_imp;
    const expert = { ...model.epl.expert.expert,
      email: model.epl.expert.email,
      userId: model.epl.expert.id,
      eplId: model.epl.id
    };
    const {
      HEDGE_FUND
    } = staticData.CONST.ACCOUNT_TYPES;
    let experienceCheck = false;

    if (model.epl.cv) {
      experienceCheck = checkExperiences(model.epl.cv.experiences);
    }

    if (model.epl.expert.cv) {
      experienceCheck = checkExperiences(model.epl.expert.cv.experiences);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "m-t-sm font-small expertsToAddExperience"
    }, !model.epl.industryExpertise || model.epl.cv && !!model.epl.cv.experiences && model.epl.cv.experiences.length < 1 || !model.epl.expert.firstName || !model.epl.expert.lastName || !model.epl.expert.address.countryId || !model.epl.expert.title ? /*#__PURE__*/React.createElement(RenderFieldsMissing, {
      model: model
    }) : null, experienceCheck === true ? null : /*#__PURE__*/React.createElement(RenderExperienceWarnings, {
      e: experienceCheck
    }), /*#__PURE__*/React.createElement(RenderEmailMissing, {
      expert: expert
    }), /*#__PURE__*/React.createElement(RenderFeeAction, {
      model: model
    }), /*#__PURE__*/React.createElement(ComplianceButton, {
      className: "m-t-sm ",
      expert: expert,
      callback: model.get,
      referrer: `project/${model.epl.projectId}/experts-pipeline/${model.epl.id}`
    }), project.office.account.parentAccount.accountTypeId === HEDGE_FUND && project.office.account.parentAccount.hedgeFundRequired && /*#__PURE__*/React.createElement(HFComplianceStatus, {
      expert: expert,
      hfCompliances: model.epl.expert.hfCompliances,
      callback: model.get
    }));
  };

  const RenderFieldsMissing = ({
    model
  }) => {
    const {
      expert
    } = model.epl;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !expert.address.countryId && /*#__PURE__*/React.createElement("div", {
      className: "message"
    }, /*#__PURE__*/React.createElement("span", {
      className: "message__error"
    }, "Country is missing on the address (Cannot submit the expert)")), !expert.title && /*#__PURE__*/React.createElement("div", {
      className: "message"
    }, /*#__PURE__*/React.createElement("span", {
      className: "message__error"
    }, "Title is missing (Cannot submit the expert)")), !expert.firstName && /*#__PURE__*/React.createElement("div", {
      className: "message"
    }, /*#__PURE__*/React.createElement("span", {
      className: "message__error"
    }, "First Name is missing (Cannot submit the expert)")), !expert.lastName && /*#__PURE__*/React.createElement("div", {
      className: "message"
    }, /*#__PURE__*/React.createElement("span", {
      className: "message__error"
    }, "Last Name is missing (Cannot submit the expert)")), model.epl.cv && model.epl.cv.experiences.length < 1 && /*#__PURE__*/React.createElement("div", {
      className: "message"
    }, /*#__PURE__*/React.createElement("span", {
      className: "message__error"
    }, "Experiences are missing (Cannot submit the expert)")), !model.epl.industryExpertise && /*#__PURE__*/React.createElement("div", {
      className: "message"
    }, /*#__PURE__*/React.createElement("span", {
      className: "message__error"
    }, "Industry Experience is missing (Cannot submit the expert)")));
  };

  const checked = id => expertsAdded.map(model => model.epl.id).includes(id);

  const ExpertsToAdd = () => {
    const MappedExperts = () => eplModels.map(model => {
      const haveFeeAndHonorarium = model.epl.fee && (model.epl.honorarium || model.epl.free);
      return /*#__PURE__*/React.createElement("div", {
        key: model.epl.id
      }, ' ', /*#__PURE__*/React.createElement("div", {
        id: model.epl.id,
        key: model.epl.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "expertToAddEPLContainer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "expertToAddTitle"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        className: "single__checkbox",
        onChange: () => {
          if (!model.epl.expert.email) {
            sendMetric('scheduling.MissingEmail', 'scheduling', {
              error: 'error'
            });
            return growlStore.showError('Email for expert missing.');
          } else if (checked(model.epl.id)) {
            dispatch({
              type: 'SETREMOVEEXPERTSADDED',
              payload: model
            });
            formatTopicAndSubject('SETREMOVEEXPERTSADDED');
          } else {
            dispatch({
              type: 'SETADDEXPERTSADDED',
              payload: model
            });
            formatTopicAndSubject('SETADDEXPERTSADDED');
          }
        },
        value: checked(model.epl.id)
      }), /*#__PURE__*/React.createElement("p", {
        className: "expertToAdd"
      }, /*#__PURE__*/React.createElement("span", {
        className: "row--link",
        onClick: () => {
          if (!model.epl.expert.email) {
            sendMetric('scheduling.MissingEmail', 'scheduling', {
              error: 'error'
            });
            return growlStore.showError('Email for expert missing.');
          } else if (checked(model.epl.id)) {
            dispatch({
              type: 'SETREMOVEEXPERTSADDED',
              payload: model
            });
            formatTopicAndSubject('SETREMOVEEXPERTSADDED');
          } else {
            dispatch({
              type: 'SETADDEXPERTSADDED',
              payload: model
            });
            formatTopicAndSubject('SETADDEXPERTSADDED');
          }
        }
      }, /*#__PURE__*/React.createElement("strong", null, model.epl.expert.title, " ", model.epl.expert.fullName)), /*#__PURE__*/React.createElement(ExpertStatusIcon, {
        expertStatusId: model.epl.expert.expert.expertStatusId,
        eplView: true
      }), ' ' + availabilityStore_imp.staticData.getDataFromArray(model.epl.expert.address.countryId, 'countries'), /*#__PURE__*/React.createElement("span", {
        className: "code-label"
      }, ' ', model.epl.expert.expert.expertCode))), /*#__PURE__*/React.createElement("div", {
        className: "expertsToAdd"
      }, /*#__PURE__*/React.createElement(RenderExperience, {
        model: model
      }), /*#__PURE__*/React.createElement(RenderWarnings, {
        model: model
      })), !haveFeeAndHonorarium && /*#__PURE__*/React.createElement("div", {
        className: "message",
        style: {
          color: '#FF5858',
          position: 'absolute',
          top: '6px',
          right: '6px'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "message__error"
      }, "Hon. & Fee Bundle missing")))));
    });

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
      style: {
        margin: '3px'
      }
    }, "Add Expert"), /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: '#f5fcff',
        padding: '5px'
      }
    }, /*#__PURE__*/React.createElement(MappedExperts, null)));
  };

  const connectedExperts = !!connectedZoomMeeting && !!connectedZoomMeeting.length ? connectedZoomMeeting.filter(meeting => meeting.expertNames.includes(availabilityStore_imp.epl.expert.fullName)).map(meeting => meeting.expertNames.split(', ').filter(experts => !experts.includes(availabilityStore_imp.epl.expert.fullName)))[0] : []; //This gets triggered when adding additional experts to schedule(expertsAdded)
  //Also contains check if other experts have already been added(connectedExperts)
  //In case of MEM we shouldn't show any names in Zoom topic or invitation subject

  const formatTopicAndSubject = action => {
    let hideExpertNameInSubject = false;

    if (action === 'SETADDEXPERTSADDED') {
      hideExpertNameInSubject = true;
    } else if (connectedExperts && connectedExperts.length) {
      hideExpertNameInSubject = true;
    } else if (expertsAdded && expertsAdded.length > 1) {
      hideExpertNameInSubject = true;
    }

    dispatch({
      type: 'UPDATE',
      payload: {
        zoomTopic: formatInvitationSubject(availabilityStore_imp, hideExpertNameInSubject),
        expertSubject: formatInvitationSubject(availabilityStore_imp, hideExpertNameInSubject),
        clientSubject: formatInvitationSubject(availabilityStore_imp, hideExpertNameInSubject)
      }
    });
  };

  const ExpertsAdded = () => {
    const MappedExperts = () => !!connectedExperts.length ? eplModel.eplStore.eplModels.filter(model => connectedExperts.includes(model.epl.expert.fullName)).map(model => {
      const haveFeeAndHonorarium = model.epl.fee && (model.epl.honorarium || model.epl.free);
      return /*#__PURE__*/React.createElement("div", {
        key: model.epl.id
      }, ' ', /*#__PURE__*/React.createElement("div", {
        id: model.epl.id,
        key: model.epl.id
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingLeft: '15px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "expertToAddTitle"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "row--link",
        onClick: () => {
          if (checked(model.epl.id)) {
            dispatch({
              type: 'SETREMOVEEXPERTSADDED',
              payload: model
            });
            formatTopicAndSubject('SETREMOVEEXPERTSADDED');
          } else {
            dispatch({
              type: 'SETADDEXPERTSADDED',
              payload: model
            });
            formatTopicAndSubject('SETADDEXPERTSADDED');
          }
        }
      }, /*#__PURE__*/React.createElement("strong", null, model.epl.expert.title, ' ', model.epl.expert.fullName)), /*#__PURE__*/React.createElement(ExpertStatusIcon, {
        expertStatusId: model.epl.expert.expert.expertStatusId,
        eplView: true
      }), ' ' + availabilityStore_imp.staticData.getDataFromArray(model.epl.expert.address.countryId, 'countries'), /*#__PURE__*/React.createElement("span", {
        className: "code-label"
      }, ' ', model.epl.expert.expert.expertCode)), /*#__PURE__*/React.createElement(RenderIcon, {
        id: model.epl.id
      })), experienceOpen === model.epl.id && /*#__PURE__*/React.createElement("div", {
        className: "expertsAdded"
      }, /*#__PURE__*/React.createElement(RenderExperience, {
        model: model
      }), /*#__PURE__*/React.createElement(RenderWarnings, {
        model: model
      })), !haveFeeAndHonorarium && /*#__PURE__*/React.createElement("div", {
        className: "message",
        style: {
          color: '#FF5858',
          position: 'absolute',
          top: '6px',
          right: '6px'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "message__error"
      }, "Hon. & Fee Bundle missing")))));
    }) : null;

    return !!MappedExperts.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
      style: {
        margin: '3px'
      }
    }, "At the meeting"), /*#__PURE__*/React.createElement(MappedExperts, null));
  };

  const ExpertsTooltip = () => {
    const renderContent = () => {
      if (!!eplModels && !eplModels.length) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, !!connectedExperts && !!connectedExperts.length && connectedExperts.map(expert => /*#__PURE__*/React.createElement("p", null, eplModel.eplStore.eplModels.filter(meeting => meeting.epl.expert.fullName === expert).map(meeting => meeting.epl.expert.title), ' ', expert)), /*#__PURE__*/React.createElement("p", null, "No Experts to add"));
      }

      if (!!connectedExperts && !!connectedExperts.length) {
        return connectedExperts.map(expert => /*#__PURE__*/React.createElement("p", null, eplModel.eplStore.eplModels.filter(meeting => meeting.epl.expert.fullName === expert).map(meeting => meeting.epl.expert.title), ' ', expert));
      }

      return /*#__PURE__*/React.createElement("p", null, "No expert connected");
    };

    return /*#__PURE__*/React.createElement("div", null, renderContent());
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-month"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overview-title"
  }, !!connectedExperts && !!connectedExperts.length ? /*#__PURE__*/React.createElement("div", {
    className: "multiMeetingTitle"
  }, /*#__PURE__*/React.createElement(IconMultiUserLarge, {
    color: 'rgba(0, 0, 0, 0.87)'
  }), /*#__PURE__*/React.createElement("h4", null, "Multi Meeting Expert Overview")) : /*#__PURE__*/React.createElement("h4", null, "Schedule Overview"), /*#__PURE__*/React.createElement("div", {
    className: "overview-title-description"
  }, "This part consists of list of the availabilities of client and expert as well as the scheduled time. You can delete or modify these timeslots."))), /*#__PURE__*/React.createElement("div", {
    className: "form-month-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-block",
    style: {
      backgroundColor: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "schedule"
  }, /*#__PURE__*/React.createElement(Schedule, {
    onDeleteTimeslot: onDeleteTimeslot,
    growlStore: growlStore,
    connectedExperts: connectedExperts
  }))), /*#__PURE__*/React.createElement("div", {
    className: "overviewActionLinks"
  }, availabilityStore_imp.schedule && (availabilityStore_imp.persistedScheduleInfo && !!availabilityStore_imp.persistedScheduleInfo.zoomMeetingId && !!availabilityStore_imp.persistedScheduleInfo.zoomMeeting || sendZoomUpdate) ? /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: ExpertsTooltip(),
    placement: "topLeft"
  }, /*#__PURE__*/React.createElement("h4", {
    style: {
      position: 'relative',
      paddingLeft: '32px'
    },
    className: `toggleCalendarButton ${!!eplModels && !!eplModels.length ? '' : 'not_allowed_cursor'}`,
    onClick: () => {
      if (!!eplModels.length) {
        dispatch({
          type: 'UPDATE',
          payload: {
            disableAddAnotherExpert: !disableAddAnotherExpert,
            showTimeslots: false
          }
        });
        return;
      }
    }
  }, !!connectedExperts && !!connectedExperts.length && /*#__PURE__*/React.createElement("span", {
    id: "connectedCount"
  }, connectedExperts.length), /*#__PURE__*/React.createElement(IconMultiUser, {
    color: '#3A86BF',
    myStyle: {
      position: 'absolute',
      left: 0
    }
  }), "Add another Expert", ' ', disableAddAnotherExpert ? /*#__PURE__*/React.createElement("i", {
    className: "arrow down"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "arrow up"
  }))) : null), availabilityStore_imp.schedule && (availabilityStore_imp.persistedScheduleInfo && !!availabilityStore_imp.persistedScheduleInfo.zoomMeetingId && !!availabilityStore_imp.persistedScheduleInfo.zoomMeeting || sendZoomUpdate) ? /*#__PURE__*/React.createElement("div", {
    id: "toggleAddAnotherExpert",
    className: `addExpertContainer ${disableAddAnotherExpert ? 'toggleAddAnotherExpertDisable' : ''}`
  }, /*#__PURE__*/React.createElement(ExpertsAdded, null), /*#__PURE__*/React.createElement(ExpertsToAdd, null)) : null, /*#__PURE__*/React.createElement("div", {
    className: `row calendar`
  }, /*#__PURE__*/React.createElement("div", {
    id: "toggleCalendar"
  }, /*#__PURE__*/React.createElement(CalendarInfo, null), /*#__PURE__*/React.createElement(OverviewCalendar, null), /*#__PURE__*/React.createElement(OverviewAvailabilities, {
    growlStore: growlStore,
    showTimeslots: true
  })))))));
};

export default Overview;